// module imports
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

// file imports
import axiosInstance from '@/lib/axios';

const getFeedbackResponses = createAsyncThunk('feedbackResponses/getFeedbackResponses', async (slug: string, { rejectWithValue }) => {
  try {
    const response = await axiosInstance.get(`/feedback/${slug}/responses`);
    return response.data;
  } catch (err: any) {
    return rejectWithValue(err.response?.data?.error || 'Retrieving feedback responses failed');
  }
});

const feedbackResponsesSlice = createSlice({
  name: 'feedbackResponses',
  initialState: {
    data: null as { questions?: any[]; responses?: any[] } | null,
    loading: false,
    error: null as string | null,
  },
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // getFeedbackResponses
      .addCase(getFeedbackResponses.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getFeedbackResponses.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(getFeedbackResponses.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });
  },
});

export { getFeedbackResponses };
export default feedbackResponsesSlice.reducer;

